import { render, staticRenderFns } from "./Dokumentenuebersicht.vue?vue&type=template&id=217da13f"
import script from "./Dokumentenuebersicht.vue?vue&type=script&lang=js"
export * from "./Dokumentenuebersicht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports